/* Pure Desi — motion round v4.9 (26 Sep 2026). Abhi: "all 15, build and push live".
   Pairs with assets/pd-motion2.css. (assets/pd-motion.js is the separate Round-6 file from 24 Jul.) Numbers match the proposal pages in Website/Plan & Audits/.
   Script-driven parts: 1 hold the delivery price's space · 3 calendar nudge · 5 gift-note height ·
   7 header back on scroll-up · 8 swipe-row nudge · 9 size-chip settle on arrival · 11 iOS :active · 13 shine once · 14 size-card photos +
   travel · 15 zoom grows from the photo. 2, 4, 6, 10, 12 are CSS only.
   Bird's markup is only read, styled or tapped the way a shopper would; never rewritten.
   ES5 on purpose (no build step, same as pd-ux.js). */
(function () {
  'use strict';
  if (window.__pdm) return;
  window.__pdm = true;

  var d = document, w = window;
  var RM = !!(w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var VT = !!(w.CSS && CSS.supports && CSS.supports('view-transition-name: none'));
  var EASE = 'cubic-bezier(.22,1,.36,1)', SHEET = 'cubic-bezier(.32,.72,0,1)';

  function ready(fn) { if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', fn); else fn(); }
  function $(s, r) { return (r || d).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); }
  function is(t) { return !!(d.body && d.body.classList.contains('template-' + t)); }
  function phone() { return !!(w.matchMedia && w.matchMedia('(max-width:767px)').matches); }
  function safe(fn) { try { fn(); } catch (e) { if (w.console && console.warn) console.warn('[pd-motion]', e); } }
  function ss(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); if (v === null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, v); } catch (_) {} return null; }
  function plainClick(e) { return !(e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey); }

  /* ---------- 1 · /cart: the step-2 delivery price has its space before it arrives ---------- */
  function holdDelivery() {
    if (!is('cart')) return;
    var host = $$('.cart-section > main > div.margin-bottom--regular').filter(function (x) {
      return !!x.querySelector('.shopify-app-block, #birdchime-slots-box');
    })[0];
    if (!host) return;
    /* 1c: pd-motion2.css held this space from the first paint; from here the placeholder holds it */
    host.classList.add('pdm-held');
    if (!$('.cart-section .cart-form-item') || host.querySelector(':scope > [data-pd-deliv2]')) return;
    var ph = d.createElement('div');
    ph.className = 'pd-deliv2';
    ph.setAttribute('data-pd-deliv2', '');
    /* the everyday bag opens on Shipping since v4.8, so its box is taller (price + headroom + event line) */
    if ((d.body.getAttribute('data-pd-mode') || '') === 'everyday') ph.style.setProperty('--pdm-d2h', '160px');
    ph.innerHTML = '<span class="pdm-sk" style="width:88%"></span><span class="pdm-sk" style="width:56%"></span>';
    host.insertBefore(ph, host.firstChild);
    /* if pd-ux.js never paints (no weight, a failed fetch), do not leave a grey box behind */
    setTimeout(function () { if (ph.parentNode && ph.querySelector('.pdm-sk')) ph.parentNode.removeChild(ph); }, 8000);
  }

  /* ---------- 3 · Diwali bag: the calendar opens on October, the next-month arrow nudges twice ---------- */
  function calendarNudge() {
    if (RM || !is('cart') || ss('pdm-nudged') || !w.MutationObserver) return;
    var mo = new MutationObserver(function () {
      if ((d.body.getAttribute('data-pd-mode') || '') !== 'diwali') return;
      var lab = $('.bird-date-grid__month');
      if (!lab || !lab.offsetParent || !/^October\b/.test((lab.textContent || '').trim())) return;
      var scope = lab.parentElement, btns = [];
      for (var i = 0; i < 3 && scope && btns.length < 2; i++) { btns = $$('button', scope); if (btns.length < 2) scope = scope.parentElement; }
      var next = btns.filter(function (b) { return !!(lab.compareDocumentPosition(b) & 4); })[0] || btns[btns.length - 1];
      if (!next || next.disabled) return;
      mo.disconnect();
      ss('pdm-nudged', '1');
      setTimeout(function () {
        next.classList.add('pdm-nudge');
        setTimeout(function () { next.classList.remove('pdm-nudge'); }, 1600);
      }, 300);
    });
    mo.observe(d.body, { childList: true, subtree: true });
  }

  /* ---------- 5 · gift note / delivery instructions open and close smoothly ---------- */
  function smoothDetails() {
    if (RM || !Element.prototype.animate) return;
    d.addEventListener('click', function (e) {
      var sum = e.target && e.target.closest ? e.target.closest('.pd-gift-note details > summary') : null;
      if (!sum) return;
      var det = sum.parentNode;
      e.preventDefault();
      if (det.__pdmBusy) return;
      det.__pdmBusy = true;
      var start = det.getBoundingClientRect().height, end, anim;
      det.style.overflow = 'hidden';
      var done = function () { det.style.overflow = ''; det.__pdmBusy = false; };
      if (!det.open) {
        det.open = true;
        end = det.getBoundingClientRect().height;
        anim = det.animate([{ height: start + 'px' }, { height: end + 'px' }], { duration: 200, easing: 'ease-out' });
        anim.onfinish = anim.oncancel = done;
        var ta = det.querySelector('textarea');
        if (ta) setTimeout(function () { try { ta.focus({ preventScroll: true }); } catch (_) {} }, 210);
      } else {
        det.open = false;
        end = det.getBoundingClientRect().height;
        det.open = true;
        anim = det.animate([{ height: start + 'px' }, { height: end + 'px' }], { duration: 160, easing: 'ease-in' });
        anim.onfinish = function () { det.open = false; done(); };
        anim.oncancel = done;
      }
    }, true);
  }

  /* ---------- 7 · phones: the header comes back when you scroll up ---------- */
  function headroom() {
    var hdr = $('main-header#site-header');
    if (!hdr || !hdr.parentElement) return;
    var sec = hdr.parentElement, fixed = false, shown = false, lastY = w.pageYOffset || 0, ticking = false, top0 = 0, limit = 0;
    function measure() {
      if (fixed) return;
      sec.style.minHeight = hdr.offsetHeight + 'px';
      var r = sec.getBoundingClientRect(), y = w.pageYOffset || 0;
      top0 = r.top + y; limit = r.bottom + y;
    }
    function set(f, s) {
      if (f !== fixed) { fixed = f; hdr.classList.toggle('pdm-hdr-fixed', f); }
      if (s !== shown) { shown = s; hdr.classList.toggle('pdm-hdr-show', s); }
    }
    function drawerOpen() { return !!$('#site-menu-sidebar.sidebar--opened, #site-cart-sidebar.sidebar--opened'); }
    function onScroll() {
      ticking = false;
      if (!phone()) { set(false, false); return; }
      if (drawerOpen()) return;
      var y = w.pageYOffset || 0, dy = y - lastY;
      lastY = y;
      if (y <= top0) { set(false, false); measure(); return; }         /* back at its own place: plain header */
      if (!fixed) { if (y > limit) set(true, false); return; }       /* only after it has fully scrolled away */
      if (dy < -6) set(true, true); else if (dy > 6) set(true, false);
    }
    measure();
    w.addEventListener('resize', function () { measure(); });
    w.addEventListener('scroll', function () { if (!ticking) { ticking = true; w.requestAnimationFrame(onScroll); } }, { passive: true });
  }

  /* ---------- 8 · a sideways row nudges once, so people see it swipes ---------- */
  function swipePeek() {
    if (RM || !w.IntersectionObserver || !Element.prototype.animate) return;
    function arm(scroller, targets, key) {
      if (!scroller || scroller.__pdmPeek || ss('pdm-peek-' + key)) return;
      scroller.__pdmPeek = true;
      var touched = false;
      scroller.addEventListener('touchstart', function () { touched = true; }, { passive: true });
      scroller.addEventListener('pointerdown', function () { touched = true; }, { passive: true });
      scroller.addEventListener('wheel', function () { touched = true; }, { passive: true });   /* not 'scroll': scroll-snap moves the row by itself */
      var io = new IntersectionObserver(function (es) {
        if (!es[0].isIntersecting) return;
        io.disconnect();
        if (touched || scroller.scrollWidth <= scroller.clientWidth + 8) return;
        ss('pdm-peek-' + key, '1');
        setTimeout(function () {
          if (touched) return;
          targets().forEach(function (t) {
            t.animate([{ transform: 'translateX(0)' }, { transform: 'translateX(-30px)', offset: 0.45 }, { transform: 'translateX(0)' }], { duration: 560, easing: EASE });
          });
        }, 250);
      }, { threshold: 0.6 });
      io.observe(scroller);
    }
    if (is('index')) {
      $$('.css-slider-holder').forEach(function (h) {
        var sec = h.closest('.shopify-section');
        if (sec && /best\s*sellers/i.test((sec.textContent || '').slice(0, 600))) arm(h, function () { return $$('.css-slider-container', h).slice(0, 1); }, 'bs');
      });
    }
    var tries = 0;
    (function sets() {
      var row = $('.pdqw-sets__row');
      if (row) { arm(row, function () { return $$(':scope > *', row); }, 'sets'); return; }
      if (++tries < 12) setTimeout(sets, 500);
    })();
  }

  /* ---------- 9 · size chips: on arrival, the boxes on screen settle in ----------
     A card-to-card morph is not possible on this theme: the new page reveals before its grid is
     parsed (0 cards in the DOM at pagereveal, tested 26 Sep), so only the arriving side moves. */
  function gridGlide() {
    if (!is('collection')) return;
    d.addEventListener('click', function (e) {
      if (!plainClick(e)) return;
      var a = e.target && e.target.closest ? e.target.closest('.pdqw-sizes a, .pd-dw2 .hv__chips a.chip') : null;
      if (a) ss('pdm-glide', String(Date.now()));
    }, true);
    var t = +(ss('pdm-glide') || 0);
    ss('pdm-glide', null);
    if (RM || !Element.prototype.animate || !t || Date.now() - t > 10000) return;   /* a stale flag (back button, slow load) does nothing */
    w.requestAnimationFrame(function () { w.requestAnimationFrame(function () {
      /* the chips link to #pd-grid and the page smooth-scrolls there after load, so pick the cards
         that will be on screen when it lands, not the ones on screen now */
      var vh = w.innerHeight, y = w.pageYOffset || 0, n = 0;
      var anchor = location.hash ? d.getElementById(location.hash.slice(1)) : null;
      var top = anchor ? anchor.getBoundingClientRect().top + y - 90 : y;
      $$('.product-item[id^="product-item-"]').forEach(function (c) {
        if (n > 7) return;
        var r = c.getBoundingClientRect(), at = r.top + y;
        if (!r.height || at + r.height < top || at > top + vh) return;
        c.animate([{ opacity: 0, transform: 'translateY(12px)' }, { opacity: 1, transform: 'none' }], { duration: 280, delay: 140 + n * 45, easing: EASE, fill: 'backwards' });
        n++;
      });
    }); });
  }

  /* ---------- 11 · iOS applies :active only when the page listens for touches ---------- */
  function pressStates() { d.addEventListener('touchstart', function () {}, { passive: true }); }

  /* ---------- 13 · Add to cart: the shine plays once when the button arrives ---------- */
  function addConfirm() {
    if (!is('product')) return;
    var main = $('.product-form [data-js-product-add-to-cart], [data-js-product-add-to-cart]');
    if (main && !RM && w.IntersectionObserver) {
      var io = new IntersectionObserver(function (es) {
        if (!es[0].isIntersecting) return;
        io.disconnect();
        setTimeout(function () {
          main.classList.add('pdm-sheen-once');
          setTimeout(function () { main.classList.remove('pdm-sheen-once'); }, 1800);
        }, 400);
      }, { threshold: 0.9 });
      io.observe(main);
    }
    /* "Added ✓" was built and taken out on 26 Sep: the theme fires its add event while the button still
       spins, then opens the cart drawer over both buttons on every add, so the tick could never be seen.
       The drawer is the confirmation. */
  }

  /* ---------- 14 · "Other sizes": each card gets its box photo, and the photo travels on tap ---------- */
  function sizePhotos() {
    if (!is('product') || !w.fetch) return;
    function fill() {
      $$('.pdqw-sz__p[href*="/products/"]').forEach(function (a) {
        if (a.__pdmImg) return;
        a.__pdmImg = true;
        var m = (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
        if (!m) return;
        fetch('/products/' + m[1] + '.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (p) {
            var src = p && (p.featured_image || (p.images && p.images[0]));
            if (!src || a.querySelector('.pdm-sz-img')) return;
            src = String(src).replace(/^https?:/, '');
            var im = d.createElement('img');
            im.className = 'pdm-sz-img';
            im.alt = '';
            im.width = 42; im.height = 42;
            im.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=120';
            a.insertBefore(im, a.firstChild);
          })
          .catch(function () {});
      });
    }
    fill();
    if (w.MutationObserver) {
      var mo = new MutationObserver(function () { if ($('.pdqw-sz')) fill(); });
      mo.observe(d.body, { childList: true, subtree: true });
      setTimeout(function () { mo.disconnect(); }, 8000);
    }
    if (RM || !VT) return;
    /* same mechanism as the 19 Sep grid morph (pd-qw.js A4): one element named pd-hero, the page's own
       hero name dropped through html.pdqw-vt-out; pd-qw.js clears both again on pageshow */
    d.addEventListener('click', function (e) {
      if (!plainClick(e)) return;
      var a = e.target && e.target.closest ? e.target.closest('.pdqw-sz__p[href*="/products/"]') : null;
      var im = a && a.querySelector('.pdm-sz-img');
      if (!im) return;
      $$('[data-pdqw-vt]').forEach(function (x) { x.style.viewTransitionName = ''; x.removeAttribute('data-pdqw-vt'); });
      d.documentElement.classList.add('pdqw-vt-out');
      im.style.viewTransitionName = 'pd-hero';
      im.setAttribute('data-pdqw-vt', '');
    }, true);
  }

  /* ---------- 15 · zoom grows from the photo you tapped, and shrinks back into it ---------- */
  function zoomMorph() {
    if (RM || !is('product') || !Element.prototype.animate) return;
    var src = null, bypass = false;
    function zoomImg() { var z = d.getElementById('zoom'); return z ? z.querySelector(':scope > img') : null; }
    function from(zi) {
      var t = zi.getBoundingClientRect(), s = src.width / (t.width || 1);
      return 'translate(' + (src.left - t.left) + 'px,' + (src.top - t.top) + 'px) scale(' + s + ')';
    }
    d.addEventListener('click', function (e) {
      var z = e.target && e.target.closest ? e.target.closest('product-image-zoom') : null;
      if (!z) return;
      var item = z.closest('.product-gallery-item'), im = item && item.querySelector('img');
      if (!im) return;
      src = im.getBoundingClientRect();
      var t0 = Date.now();
      (function wait() {
        var zc = d.getElementById('zoom'), zi = zoomImg();
        if (zc && zc.classList.contains('opened') && zi && zi.complete && zi.naturalWidth && zi.getBoundingClientRect().width > 0) {
          zi.style.transformOrigin = '0 0';
          zi.animate([{ transform: from(zi) }, { transform: 'none' }], { duration: 320, easing: SHEET });
          return;
        }
        if (Date.now() - t0 < 1500) w.requestAnimationFrame(wait);
      })();
    }, true);
    d.addEventListener('click', function (e) {
      if (bypass) return;
      var ex = e.target && e.target.closest ? e.target.closest('#zoom .zoom__exit') : null;
      var zi = zoomImg();
      if (!ex || !zi || !src) return;
      e.preventDefault(); e.stopPropagation();
      zi.style.transformOrigin = '0 0';
      var a = zi.animate([{ transform: 'none' }, { transform: from(zi) }], { duration: 240, easing: 'cubic-bezier(.4,0,1,1)', fill: 'forwards' });
      a.onfinish = function () {
        bypass = true;
        try { ex.click(); } finally { bypass = false; }
        setTimeout(function () { try { a.cancel(); } catch (_) {} }, 260);
      };
    }, true);
  }

  ready(function () {
    safe(holdDelivery);
    safe(calendarNudge);
    safe(smoothDetails);
    safe(headroom);
    safe(swipePeek);
    safe(gridGlide);
    safe(pressStates);
    safe(addConfirm);
    safe(sizePhotos);
    safe(zoomMorph);
  });
})();
